import { Box, Divider, Link, Stack } from '@mui/material';
import { Footer, FooterText } from 'components/help/HelpContainerStyled';
import styles from 'features/DefaultHelp.module.css';
import ControlsSection from './Controls';
import InstructionsSection from './Instruction';
import OverviewSection from './Overview';

const HomePageHelpDialog = () => {
    return (
        <Stack className={styles['help-dialog-container']}>
            <Box className={styles['help-dialog-content-container']}>
                <OverviewSection />
                <Divider className={styles['divider']} />
                <ControlsSection />
                <Divider className={styles['divider']} />
                <InstructionsSection />
            </Box>
            <Footer>
                <FooterText>
                    {`For further support, email us at `}
                    <Link href="mailto:cs@birdseye.ca" underline="none">
                        cs@birdseye.ca.
                    </Link>
                </FooterText>
            </Footer>
        </Stack>
    );
};

export default HomePageHelpDialog;
